import { Lock, Users, Globe } from 'lucide-react'
import type { SpaceType } from '@/types'
import './SpaceSelector.css'

type Selectable = Extract<SpaceType, 'private' | 'dept' | 'public'>

interface SpaceSelectorProps {
  value: Selectable
  onChange: (value: Selectable) => void
  hasDept: boolean
}

const options: { value: Selectable; label: string; Icon: typeof Lock; desc: string }[] = [
  { value: 'private', label: '仅自己可见',   Icon: Lock,   desc: '只有你能访问' },
  { value: 'dept',    label: '本部门可见',   Icon: Users,  desc: '所属部门成员可见' },
  { value: 'public',  label: '全员可见',     Icon: Globe,  desc: '公司全员都能访问' },
]

export function SpaceSelector({ value, onChange, hasDept }: SpaceSelectorProps) {
  return (
    <div className="space-selector">
      <span className="space-selector-label">可见范围：</span>
      <div className="space-selector-tabs">
        {options.map(({ value: v, label, Icon, desc }) => {
          const disabled = v === 'dept' && !hasDept
          return (
            <button
              key={v}
              type="button"
              className={`space-tab ${value === v ? 'active' : ''}`}
              disabled={disabled}
              onClick={() => !disabled && onChange(v)}
              title={disabled ? '你尚未归属任何部门' : desc}
            >
              <Icon size={14} />
              <span>{label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
